import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import StatCard from '../common/StatCard'
import OrderedStylesBySource from './SourcingTrends/OrderedStylesBySource'
import { openLoader, closeLoader } from '../../../redux_toolkit/Loader'
import { fetchOverviewSummary } from '../../../services/v3/Dashboard/Dashborad'
import { authUserInfo } from '../../../helpers/Util'

const formatCount = (value) => Number(value ?? 0).toLocaleString('en-US')

const formatCompact = (value) => {
    const num = Number(value ?? 0)
    if (Math.abs(num) >= 1000000) return `${(num / 1000000).toFixed(1)}M`
    if (Math.abs(num) >= 1000) return `${(num / 1000).toFixed(1)}K`
    return formatCount(num)
}

const formatCurrency = (value) => `$${formatCompact(value)}`

const buildStatCards = (summary) => [
    {
        value: formatCurrency(summary?.sourcedThroughNitex),
        label: 'Sourced through Nitex'
    },
    { value: formatCount(summary?.numberOfStyles), label: 'No. of styles' },
    { value: formatCount(summary?.totalQuantity), label: 'Total quantity' }
]

const OverviewSummary = ({ dateRange }) => {
    const dispatch = useDispatch()
    const [summary, setSummary] = useState(null)

    useEffect(() => {
        getOverviewSummary()
    }, [dateRange?.type, dateRange?.fromDate, dateRange?.toDate])

    const getOverviewSummary = async () => {
        const brandId = authUserInfo()?.brandResponse?.id
        if (!brandId) return
        try {
            dispatch(openLoader())
            const isCustom = dateRange?.type === 'CUSTOM'
            const params = {
                dateRangeType: dateRange?.type || 'ALL_TIME',
                startDate: isCustom ? dateRange?.fromDate : undefined,
                endDate: isCustom ? dateRange?.toDate : undefined
            }
            const data = await fetchOverviewSummary(brandId, params)
            setSummary(data)
        } catch (error) {
            setSummary(null)
        } finally {
            dispatch(closeLoader())
        }
    }

    return (
        <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
            {buildStatCards(summary).map((card) => (
                <StatCard
                    key={card.label}
                    value={card.value}
                    label={card.label}
                />
            ))}
            <OrderedStylesBySource sourcingData={summary} />
        </div>
    )
}

export default OverviewSummary
